import React, { useEffect, useState } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";

import {
  Checkbox,
  FormGroup,
  FormControlLabel,
  Box,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import MenuPopper from "../atoms/MenuPopper";
import StyledButton from "../atoms/StyledButton";
import CheckboxIcon from "../atoms/icons/CheckboxIcon";
import useCnaeContext from "../../contexts/CnaeContext";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "374px",
    "& .MuiFormControlLabel-root": {
      margin: 0,
    },
    position: "relative",
    zIndex: 2,
    "& .MuiPaper-rounded": {
      borderRadius: "4px !important",
    },
  },
  wrapper: {
    padding: "24px",
  },

  headerFilter: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "22px",
  },
  checkboxItem: {
    borderBottom: "1px solid #F0F0F0",
    "& .MuiFormControlLabel-label": {
      margin: 0,
    },
  },
  noBorder: {
    borderBottom: "none",
  },
}));

export default function Dropdown({ menuAnchor, setMenuAnchor, filtersLength }) {
  const classes = useStyles();
  const { filters, setFilters } = useCnaeContext();

  function setCheckedOption(option) {
    setFilters({
      ...filters,
      [option]: !filters[option],
    });
  }

  function clean() {
    setFilters({
      permitido: false,
      impedido: false,
      ambiguo: false,
    });
  }

  function concluded() {
    setMenuAnchor(null);
    const result = Object.keys(filters).filter(
      (check) => filters[check] === true
    );
    filtersLength(result);
  }

  return (
    <MenuPopper
      menuAnchor={menuAnchor}
      setMenuAnchor={setMenuAnchor}
      className={classes.container}
      placement={"bottom-end"}
    >
      <Box className={classes.wrapper}>
        <Box className={classes.headerFilter}>
          <StyledButton
            onClick={() => clean()}
            text={"Limpar"}
            type={"dashed"}
            height={"24px"}
            style={{
              fontWeight: "400",
              borderColor: "#0093f5",
              color: "#0093f5",
            }}
          />
          <Typography>Filtro</Typography>
          <StyledButton
            onClick={() => concluded()}
            text={"Concluído"}
            type={"filled"}
            height={"24px"}
            style={{ fontWeight: "400", backgroundColor: "#0093f5" }}
          />
        </Box>
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                color={"primary"}
                checked={filters.permitido}
                onChange={() => setCheckedOption("permitido")}
                icon={<CheckboxIcon />}
              />
            }
            label={"Permitido"}
            className={classes.checkboxItem}
          />

          <FormControlLabel
            control={
              <Checkbox
                color={"primary"}
                checked={filters.impedido}
                onChange={() => setCheckedOption("impedido")}
                icon={<CheckboxIcon />}
              />
            }
            label={"Impeditivo"}
            className={classes.checkboxItem}
          />

          <FormControlLabel
            control={
              <Checkbox
                color={"primary"}
                checked={filters.ambiguo}
                onChange={() => setCheckedOption("ambiguo")}
                className={classes.checkbox}
                icon={<CheckboxIcon />}
              />
            }
            label={"Ambíguo"}
            className={clsx(classes.checkboxItem, classes.noBorder)}
          />
        </FormGroup>
      </Box>
    </MenuPopper>
  );
}

Dropdown.propTypes = {
  menuAnchor: PropTypes.element.isRequired,
  setMenuAnchor: PropTypes.func.isRequired,
  filtersLength: PropTypes.func.isRequired,
};
